import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { AnonModuleParentsPanel } from '../ParentsPanel/AnonModuleParentsPanel';
import AnonModuleView from '../AnonModuleView';
import { Body } from 'src/presentation/components/forms/Layout';
import { closeAnonModule } from 'src/presentation/components/pages/sidekick/threads/actions/anonUiActions';
import { ControlBarAnon } from './ControlBarAnon';
import {
  SIDE_PANEL_WIDTH,
  THREAD_FLOW_TOP_MARGIN,
} from 'src/presentation/components/pages/sidekick/threads/SidekickConstants';
import EditorLayout from './EditorLayout';

type AnonymousModuleEditorProps = {
  readOnly: boolean;
  onClose: () => void;
};

const AnonymousModuleEditor = ({ readOnly, onClose }: AnonymousModuleEditorProps) => {
  const dispatch = useDispatch();

  const handleBackToModule = () => {
    dispatch(closeAnonModule({ history }));
    onClose();
  };

  return (
    <StyledBody>
      <EditorLayout
        id="anon-connectors"
        controlBarControl={<ControlBarAnon className="controlBar" onBackToModule={handleBackToModule} />}
        hasModules={true}
        isAnonymousModule={true}
        moduleViewControl={<AnonModuleView disabled={readOnly} />}
        readOnly={readOnly}
        renderParentsPanel={(params: any) => <AnonModuleParentsPanel {...params} onBackToModule={handleBackToModule} />}
      />
    </StyledBody>
  );
};

export const StyledBody = styled(Body)`
  display: flex;
  align-items: center;
  padding: 0;
  max-width: 100%;
  width: ${`calc(100% - ${SIDE_PANEL_WIDTH})`};
  height: calc(100vh - ${THREAD_FLOW_TOP_MARGIN});
  margin-right: auto;
`;

export default memo(AnonymousModuleEditor);
